The pagination metadata for this page of subscriptions.
